import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const topArticles = articles.filter(a => a.rank <= 3);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % topArticles.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + topArticles.length) % topArticles.length);

  const article = topArticles[currentSlide];

  return (
    <section className="relative min-h-[480px] md:min-h-[620px] flex items-end overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-accent-100/30 to-secondary-100/40"></div>

      <div className="relative w-full px-4 md:px-6 pt-24 pb-10 md:pb-14">
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16">
          <div className="lg:w-[60%] space-y-5">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/80 text-accent-600 text-xs font-semibold whitespace-nowrap">
              <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
              今日热榜 TOP {article.rank}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-900 leading-tight tracking-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-3 text-foreground-500 text-sm">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万
              </span>
              <span>·</span>
              <span>{article.publishedAt}</span>
              <span>·</span>
              <span className="text-accent-500 font-medium">{article.category}</span>
            </div>
          </div>

          <div className="lg:w-[40%] space-y-5">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              {article.excerpt}
            </p>
            <div className="flex items-center gap-4">
              <Link
                to={`/article/${article.slug}`}
                className="px-5 py-2.5 rounded-lg bg-primary-900 text-background-50 text-sm font-semibold hover:bg-primary-800 transition-colors whitespace-nowrap"
              >
                阅读全文
              </Link>
              <button
                onClick={nextSlide}
                className="text-foreground-600 text-sm font-medium hover:text-accent-500 transition-colors whitespace-nowrap flex items-center gap-1"
              >
                下一条 <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            <div className="flex items-center gap-2 mt-4">
              <button
                onClick={prevSlide}
                className="w-8 h-8 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-500 hover:border-accent-400 hover:text-accent-500 transition-colors"
              >
                <i className="ri-arrow-left-s-line text-sm"></i>
              </button>
              <button
                onClick={nextSlide}
                className="w-8 h-8 rounded-full bg-primary-900 flex items-center justify-center text-background-50 hover:bg-primary-800 transition-colors"
              >
                <i className="ri-arrow-right-s-line text-sm"></i>
              </button>
              <div className="flex items-center gap-1.5 ml-3">
                {topArticles.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentSlide(i)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      i === currentSlide ? 'bg-accent-500 w-5' : 'bg-foreground-300/50'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-48 md:h-72 object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}